export default "__VITE_ASSET__TBEY9oC1__"